import {

  GET_ROLE_DEFINITIONS_SUCCESS,
  ADD_ROLE_DEFINITION_SUCCESS,
  UPDATE_ROLE_DEFINITION_SUCCESS,
  DELETE_ROLE_DEFINITION_SUCCESS,
  PAGE_OPERATION_LIST_SUCCESS,
  PAGE_OPERATION_LIST_FOR_VALUE_SUCCESS,
  ROLE_DEFINITION_API_ERROR,

} from "./actionTypes"

const INIT_STATE = {
  roleDefinitions: [],
  recordList: [],
  operationList: [],
  recordGet: false,
  error: {},
}

const RoleDefinition = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_ROLE_DEFINITIONS_SUCCESS:
      return {
        ...state,
        roleDefinitions: action.payload,
      }

    case ADD_ROLE_DEFINITION_SUCCESS:
      return {
        ...state,
        roleDefinitions: action.payload.roleVM,
        recordList: action.payload.pageVm,
      }

    case UPDATE_ROLE_DEFINITION_SUCCESS:
      return {
        ...state,
        roleDefinitions: action.payload.roleVM,
        recordList: action.payload.pageVm,
      }

    case DELETE_ROLE_DEFINITION_SUCCESS:
      return {
        ...state,
        roleDefinitions: state.roleDefinitions.filter(
          record => record.guid !== action.payload
        ),
      }

    case PAGE_OPERATION_LIST_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
      }

    case PAGE_OPERATION_LIST_FOR_VALUE_SUCCESS:
      return {
        ...state,
        operationList: action.payload,

      }
    case ROLE_DEFINITION_API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    default:

      return state

  }
}

export default RoleDefinition